<!-- eslint-disable max-len -->
<template>
  <div class="dashboard-block release-shortcut-nav__area">
    <div class="release-shortcut-nav__inner-area">
      <router-link
        :to="{ name: 'release-single' }"
        class="release-shortcut-nav__link-area"
        href="">
        <div class="release-shortcut-nav__link-inner-area">
          <div class="release-shortcut-nav__item-icon">
            <svg
              class="icon-add_artist_db svg-icon"
              width="60"
              height="64"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              viewBox="16 10 85 90">
              <path
                class="color2"
                fill-rule="evenodd"
                d="M75.609,96.86H23.753a4.19,4.19,0,0,1-4.167-4.2V19.06a4.187,
                4.187,0,0,1,4.162-4.2H68.721c1.451,0,7.026,5.222,16.57,15.52a1,
                1,0,0,1-1.467,1.36c-6.382-6.887-13.753-14.271-15.2-14.88H23.753a2.182,
                2.182,0,0,0-2.167,2.194V92.66a2.187,2.187,0,0,0,2.172,2.2H73.769A15.029,
                15.029,0,0,0,75.609,96.86Zm9.949-62H72.384c-2.279,
                0-2.663-.894-2.663-2.9V20.66a1,1,0,1,0-2,0v11.3c0,2.1.483,4.9,4.663,
                4.9H83.558V71.148a14.651,14.651,0,0,1,2-.152Z" />
              <path
                class="color1"
                fill-rule="evenodd"
                d="M65.559,66.815v-25.8a1.156,1.156,0,0,0-.479-.938,1.127,1.127,0,0,
                0-1.035-.141L44.223,47.1a1.144,1.144,0,0,0-.751,1.079V70.611a5.627,
                5.627,0,0,0-4.058-.481c-3.282.707-5.853,3.5-5.853,6.353a4.153,4.153,
                0,0,0,1.527,3.277,5.193,5.193,0,0,0,3.328,1.1,6.938,6.938,0,0,0,
                1.471-.158c3.283-.707,5.853-3.5,5.853-6.353,
                0-.125-.028-.244-.037-.367h.034V56.154L63.3,49.806V63.445a5.62,5.62,
                0,0,0-4.059-.481c-3.282.707-5.853,3.5-5.853,6.352a4.155,4.155,0,0,0,
                1.527,3.278,5.193,5.193,0,0,0,3.328,1.1v-.006a7.064,7.064,0,0,0,
                1.471-.152c3.283-.707,5.853-3.5,5.853-6.353,
                0-.125-.028-.245-.037-.368ZM39.413,78.457a3.428,3.428,0,0,1-2.9-.483,
                1.838,1.838,0,0,1-.687-1.493c0-1.754,1.858-3.636,4.058-4.11a4.869,4.869,
                0,0,1,1.007-.111v-.006a2.96,2.96,0,0,1,1.893.6,1.843,1.843,0,0,1,.687,
                1.493C43.471,76.1,41.613,77.983,39.413,78.457Zm19.823-7.166a3.425,3.425,
                0,0,1-2.9-.483,1.838,1.838,0,0,1-.688-1.494c0-1.754,1.858-3.635,
                4.058-4.109a4.794,4.794,0,0,1,1.007-.111v-.007a2.965,2.965,0,0,1,
                1.894.6,1.843,1.843,0,0,1,.688,1.494C63.3,68.935,61.436,70.817,59.236,
                71.291ZM63.3,47.371,45.737,53.72V48.98L63.3,42.632ZM91.572,85.86a1,1,0,
                0,1-1,1h-4v4a1,1,0,1,1-2,0v-4h-4a1,1,0,0,1,0-2h4v-4a1,1,0,0,1,2,0v4h4A1,
                1,0,0,1,91.572,85.86ZM85.572,73A12.865,12.865,0,1,0,98.436,85.86,12.879,
                12.879,0,0,0,85.572,73Zm0,23.865a11,11,0,1,1,11-11A11.012,11.012,0,0,1,
                85.572,96.86Z" />
            </svg>
          </div>
          <div class="release-shortcut-nav__item-text">
            シングル（1曲）を配信する
            <span class="c-btn__icon-arrow c-btn__icon-arrow--def release-shortcut-nav__arrow"></span>
          </div>
        </div>
      </router-link>
      <router-link
        :to="{ name: 'release-album' }"
        class="release-shortcut-nav__link-area"
        href="">
        <div class="release-shortcut-nav__link-inner-area">
          <div class="release-shortcut-nav__item-icon">
            <svg
              class="icon-add_artist_db svg-icon"
              width="60"
              height="64"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              viewBox="16 10 85 90">
              <path
                class="color2"
                fill-rule="evenodd"
                d="M81.708,69.828c-.057,0-.112.008-.169.009V34.693H70.4c-4.17,
                0-4.652-2.8-4.652-4.9v-11.3a1,1,0,1,1,2,0v11.3c0,2.25.594,2.9,2.652,
                2.9H83.539v37.26A14.959,14.959,0,0,0,81.708,69.828Zm12.986,22.08a14.931,
                14.931,0,0,1-8.034,6.783h1.9c.109.007.217.01.325.01A5.832,5.832,0,0,0,
                94.7,93.187a4.9,4.9,0,0,0,0-.694Zm0-46.215a1,1,0,0,0-2,0V74.717a14.9,14.9,
                0,0,1,2,2.762Zm-64.808,39a2.182,2.182,0,0,1-2.164-2.2V16.887a2.18,2.18,0,
                0,1,2.158-2.194H66.645c1.447.612,8.8,7.995,15.158,14.879a1,1,0,0,0,
                1.469-1.358c-9.518-10.3-15.079-15.521-16.527-15.521H29.873a4.183,4.183,0,
                0,0-4.151,4.2V82.486a4.185,4.185,0,0,0,4.158,4.207H66.994a14.824,14.824,0,
                0,1-.151-2Zm58.9-45a1,1,0,0,0-2,0l0,31.05a14.82,14.82,0,0,1,2,.884Zm-52.926,
                51a1,1,0,1,0,0,2H69.2a14.844,14.844,0,0,1-1.08-2Zm5.9,6a1,1,0,1,0,0,
                2H76.757a14.8,14.8,0,0,1-3.785-2Z" />
              <path
                class="color1"
                fill-rule="evenodd"
                d="M81.708,71.828A12.865,12.865,0,1,0,94.572,84.693,12.88,12.88,0,0,0,81.708,
                71.828Zm0,23.865a11,11,0,1,1,11-11A11.012,11.012,0,0,1,81.708,95.693Zm6-11a1,
                1,0,0,1-1,1h-4v4a1,1,0,1,1-2,0v-4h-4a1,1,0,0,1,0-2h4v-4a1,1,0,0,1,2,0v4h4A1,1,
                0,0,1,87.708,84.693Zm-17-27.119a1,1,0,0,0,2,
                0c0-3.526-1.093-4.5-2.638-5.488a5.435,5.435,0,0,1-2.446-2.781,1,1,0,0,
                0-1.916.4V66.029A4.2,4.2,0,0,0,63,65.813c-2.406.511-4.292,2.543-4.292,
                4.626a3.079,3.079,0,0,0,1.152,2.44,3.9,3.9,0,0,0,2.478.814,5.148,5.148,0,0,0,
                1.078-.115c2.406-.511,4.292-2.542,4.292-4.625,0-.058-.015-.114-.018-.172,
                0-.031.018-.057.018-.088V52.84a10.092,10.092,0,0,0,1.283.929C70.1,54.474,70.708,
                54.868,70.708,57.574ZM63,71.621a2.287,2.287,0,0,1-1.881-.3,1.085,1.085,0,0,
                1-.411-.886c0-1.136,1.24-2.359,2.708-2.67a3.184,3.184,0,0,1,.66-.072v0a1.942,1.942,
                0,0,1,1.221.367,1.091,1.091,0,0,1,.411.886C65.708,70.087,64.468,71.309,63,
                71.621ZM58.69,56.785a.82.82,0,0,0,.018-.086V37.707a1,1,0,0,0-1.336-.941l-14,5a1,1,0,
                0,0-.664.942V47.7h0V59.033A4.218,4.218,0,0,0,40,58.817c-2.406.511-4.292,
                2.543-4.292,4.626a3.077,3.077,0,0,0,1.152,2.436,3.9,3.9,0,0,0,2.478.814,5.143,5.143,
                0,0,0,1.078-.11c2.406-.511,4.292-2.543,4.292-4.626,
                0-.058-.015-.113-.018-.171a.838.838,0,0,0,.018-.087V48.4l12-4.286V54.03A4.2,4.2,0,0,
                0,54,53.814c-2.406.511-4.292,2.542-4.292,4.625a3.079,3.079,0,0,0,1.152,2.44,3.9,3.9,
                0,0,0,2.478.814V61.7a5.217,5.217,0,0,0,1.078-.116c2.406-.511,4.292-2.543,
                4.292-4.626C58.708,56.9,58.693,56.843,58.69,56.785ZM40,64.621a2.283,2.283,0,0,
                1-1.881-.3,1.085,1.085,0,0,1-.411-.886c0-1.136,1.24-2.359,2.708-2.67a3.184,3.184,0,0,
                1,.66-.072V60.7a1.947,1.947,0,0,1,1.221.364,1.091,1.091,0,0,1,.411.886C42.708,63.087,
                41.468,64.309,40,64.621Zm4.708-18.34V43.412l12-4.284V42ZM54,59.621a2.291,2.291,0,0,
                1-1.881-.3,1.085,1.085,0,0,1-.411-.886c0-1.136,1.24-2.358,2.708-2.67a3.184,3.184,0,
                0,1,.66-.072v.01a1.945,1.945,0,0,1,1.221.361,1.092,1.092,0,0,1,.411.886C56.708,
                58.086,55.468,59.309,54,59.621Z" />
            </svg>
          </div>
          <div class="release-shortcut-nav__item-text">
            アルバム（2曲以上）を配信する
            <span class="c-btn__icon-arrow c-btn__icon-arrow--def release-shortcut-nav__arrow"></span>
          </div>
        </div>
      </router-link>
    </div>
  </div>
</template>
<!-- eslint-enable max-len -->
<script>
export default {
  name: 'DashboardReleaseShortcutNav',
}
</script>
